import styles from "./Layout.module.scss";
import { Header } from "components/layout/header/Header";
import { Footer } from "components/layout/footer/Footer";
import { IdlePopup } from "components/shared/IdlePopup";
import { StructuredData } from "@/components/head/StructuredData";
import { BreadcrumbsProps } from "@/components/shared/Breadcrumbs";

type LayoutProps = {
  children: React.ReactNode;
  breadcrumbs?: BreadcrumbsProps;
  title: string;
  description: string;
  isArticle?: boolean;
  categoryName?: string;
  datePublished?: string;
  dateUpdated?: string;
  isCollectionPage?: boolean;
  tags?: string[];
  h1?: string;
};

export const Layout = ({ children, ...metaProps }: LayoutProps) => {
  return (
    <>
      <StructuredData {...metaProps} />

      <Header />
      <div className={styles.layout}>
        <div className={styles.layoutInner}>{children}</div>
        <Footer />
      </div>
      <IdlePopup />
    </>
  );
};
